import React from "react";
import { Grid, Paper, Typography } from "@mui/material";

const MonthlyStatistics = ({ summaryData }) => {
  const totalOrders = summaryData?.totalOrders || 0;
  const totalDelivered = summaryData?.deliveredOrders || 0;
  const workingDays = summaryData?.workingDays || 0;
  const totalHours = summaryData?.totalHours || 0;

  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#e3f2fd" }}
        >
          <Typography variant="caption" color="primary" fontWeight="medium">
            Total Orders
          </Typography>
          <Typography variant="h4" fontWeight="bold" color="primary">
            {totalOrders}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#e8f5e8" }}
        >
          <Typography
            variant="caption"
            color="success.main"
            fontWeight="medium"
          >
            Delivered
          </Typography>
          <Typography variant="h4" fontWeight="bold" color="success.main">
            {totalDelivered}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#fff3e0" }}
        >
          <Typography
            variant="caption"
            fontWeight="medium"
            sx={{ color: "#ef6c00" }}
          >
            Working Days
          </Typography>
          <Typography variant="h4" fontWeight="bold" sx={{ color: "#ef6c00" }}>
            {workingDays}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#f3e5f5" }}
        >
          <Typography
            variant="caption"
            color="secondary.main"
            fontWeight="medium"
          >
            Total Hours
          </Typography>
          <Typography variant="h4" fontWeight="bold" color="secondary.main">
            {totalHours}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default MonthlyStatistics;
